// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"9f336554","769":"4c90525d"}[chunkId] + ".chunk.js";
};